import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInfoChat } from "./Store/Actions/chat-button.actions";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import { animations } from "react-animation";
import Button from "react-bootstrap/Button";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { maskNumber } from "../../../../@helpers/utils";
import "./bootstrap.css";
import "./chatFormulario.css";
import { ChatDesol } from "./ChatDesol";
import { isEmpty } from "lodash";
import Parser from "html-react-parser";
import moment from "moment";
import "moment/locale/es";
import { remAccents } from "@helpers/utils";
import Swal from "sweetalert2";
moment.locale("es");

function ChatFormulario() {
  const dispatch = useDispatch();
  const BORDER_TOP_COLOR = "#d7de00";
  const [changeValue, setChangeValue] = useState(true);
  const [maskId, setMaskId] = useState(9);
  const [formato, setFormato] = useState("Formato: 123456789");
  const [url, setUrl] = useState(process.env.REACT_APP_CHAT_SERVICIO_CLIENTE_URL);
  const { textoInformativo } = useSelector(({ Base }) => Base.Chat);
  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const defRoute = rutas?.filter((route) => route?.name === "ChatForm" && route?.identificadorSitio === "AC");
  const [tituloInfo, setTituloInfo] = useState("");
  const [info, setInfo] = useState("");
  const [textoChatIniciado, setTextoChatIniciado] = useState("");
  const [status, setStatus] = useState(false);
  const [mensajeFueraHorario, setMensajeFueraHorario] = useState("");

  const [initialValues, setInitialValues] = useState({
    idType: "1",
    id: "",
    name: "",
    email: "",
    typeChat: "1",
    detail: "",
  });
  const schemaValidation = Yup.object().shape({
    idType: Yup.string().required("Dato requerido"),
    id: Yup.string()
      .required("Dato requerido")
      .typeError("Solo permite números [0-9]")
      .min(
        maskId,
        "Favor revisar la cantidad ya que contiene valores menores a " +
          maskId +
          " caracteres"
      ),
    name: Yup.string().required("Dato requerido"),
    email: Yup.string()
      .required("Dato requerido")
      .email("Ingrese un correo válido"),
    typeChat: Yup.string()
      .label("Favor seleccionar el tipo de chat correcto")
      .typeError("Favor seleccionar el tipo de chat correcto"),
    detail: Yup.string().required("Dato requerido"),
  });

  const onChangeIdType = (e) => {
    if (e === "1") {
      setMaskId(9);
      setFormato("Formato: 123456789");
    } else if (e === "2") {
      setMaskId(10);
      setFormato("Formato: 3123123456");
    } else if (e === "3") {
      setMaskId(12);
      setFormato("Formato: 1NNNCCCCCCDV");
    }
  };

  const urlChange = (e) => {
    if (e.target.value === "1") {
      setUrl(process.env.REACT_APP_CHAT_SERVICIO_CLIENTE_URL);
    } else {
      setUrl(process.env.REACT_APP_CHAT_COBROS_URL);
    }
  };

  const checkStatusButton = () => {
    if (!isEmpty(textoInformativo)) {
      //obtenemos el nombre del día actual sin tildes y con inicial mayúscula.
      const dayBase = moment().locale("es").format("dddd");
      const dayStr = dayBase.toString();
      var dayStrName = dayStr.charAt(0).toUpperCase() + dayStr.slice(1);
      dayStrName = remAccents(dayStrName);

      //obtenemos la lista de nombres de campos del  Selector "textoInformativo".
      const daysKeys = Object.keys(textoInformativo[0]);

      //filtramos los nombres de campos para obtener los que contengan el nombre del día.
      const daySchedule = daysKeys.filter((item) => item.includes(dayStrName));
      //Filtramos los campos por nombre para obtener la hora de inicio y fin, que contengan el nombre del día.
      const filteredSchedule = Object.keys(textoInformativo[0])
        .filter((key) => daySchedule.includes(key))
        .reduce((obj, key) => {
          obj[key] = textoInformativo[0][key];
          return obj;
        }, {});

      //Obtenemos los valores de inicio y fin del rango de horario.
      const scheduleRange = Object.entries(filteredSchedule);
      const scheduleRangeFrom = scheduleRange[0];
      const scheduleRangeTo = scheduleRange[1];

      //Obtenemos por separado la hora y minuto actual.
      let curTime = moment().locale("es").format("LTS");

      //validamos que la hora esté en el rango.
      let result =
        moment(curTime, "HH:mm:ss").isAfter(
          moment(scheduleRangeFrom[1], "HH:mm:ss")
        ) &&
        moment(curTime, "HH:mm:ss").isBefore(
          moment(scheduleRangeTo[1], "HH:mm:ss")
        );

      return result;
    } else {
      return false;
    }
  };

  const handleStartChat = () => {
    const estatusHorario = checkStatusButton();
    if(estatusHorario) {
      setChangeValue(!changeValue);
    } else {
      Swal.fire({
        title: '¡Lo sentimos!',
        text: 'El chat se encuentra fuera de horario',
        icon: 'warning',
      })
    }
  }

  useEffect(() => {
    dispatch(getInfoChat());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(textoInformativo)) {
      let texto = textoInformativo[0]?.textoChat?.html?.toString();
      let titulo = textoInformativo[0]?.titulodelformulario?.html?.toString();
      let textoIniciado = textoInformativo[0]?.textoChatIniciado?.html?.toString();
      let mensajeFueraHorarioStr = textoInformativo[0]?.mensajeFueradeHorario?.html?.toString();

      setTituloInfo(titulo);
      setInfo(texto);
      setTextoChatIniciado(textoIniciado);
      setStatus(checkStatusButton());
      setMensajeFueraHorario(mensajeFueraHorarioStr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textoInformativo]);

  return (
    <div style={{ animation: animations.fadeIn }}>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.title} />
      <h1 className="titulo_tt_h1">{Parser(tituloInfo)}</h1>
      <div
        className={"text_tt2"}
        style={{ borderTop: "3px solid " + BORDER_TOP_COLOR }}
      >
        {status ? (
          <>
            {changeValue ? (
              <>
                <div className="subtitulo_tt">{Parser(info)}</div>
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={schemaValidation}
                  onSubmit={(values) => {
                    handleStartChat()
                  }}
                >
                  {({ setFieldValue, errors, touched }) => (
                    <Form>
                      <div className="container">
                        <div className="row justify-content-start">
                          <div className="col-12">
                            <div className="row">
                              <div className="col-lg-6 col-sm-12">
                                <p className="mt-5 h3 fw-bold">Datos Personales</p>
                                <div className="mb-3">
                                  <label className="mb-2 fw-bold2">
                                    Tipo de Identificación:
                                  </label>
                                  <select
                                    name="idType"
                                    className="form-select"
                                    value={initialValues.idType}
                                    onChange={(val) => {
                                      setFieldValue("idType", val.target.value);
                                      setInitialValues({
                                        ...initialValues,
                                        idType: val.target.value,
                                        id: "",
                                      });
                                      onChangeIdType(val.target.value);
                                    }}
                                  >
                                    <option value="1">Física</option>
                                    <option value="2">Jurídica</option>
                                    <option value="3">Extranjero Residente</option>
                                  </select>
                                  {errors.idType && touched.idType && (
                                    <div className="invalid-feedback d-block">
                                      {errors.idType}
                                    </div>
                                  )}
                                </div>
                                <div className="mb-3 mt-5">
                                  <label className="mb-2 fw-bold2">
                                    Número de Identificación:
                                  </label>
                                  <Field
                                    type="text"
                                    name="id"
                                    className="form-control"
                                    value={initialValues.id}
                                    autoComplete="off"
                                    placeholder={formato}
                                    maxLength={maskId}
                                    onChange={(e) => {
                                      setFieldValue("id", maskNumber(e.target.value));
                                      setInitialValues({
                                        ...initialValues,
                                        id: maskNumber(e.target.value),
                                      });
                                    }}
                                  />
                                  {errors.id && touched.id && (
                                    <div className="invalid-feedback d-block">
                                      {errors.id}
                                    </div>
                                  )}
                                </div>
                                <div className="mb-3 mt-5">
                                  <label className="mb-2 fw-bold2">
                                    Nombre Completo:
                                  </label>
                                  <Field
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    value={initialValues.name}
                                    placeholder="Ingrese su nombre y apellidos"
                                    onChange={(e) => {
                                      setFieldValue(
                                        "name",
                                        maskNumber(e.target.value)
                                      );
                                      setInitialValues({
                                        ...initialValues,
                                        name: e.target.value,
                                      });
                                    }}
                                  />
                                  {errors.name && touched.name && (
                                    <div className="invalid-feedback d-block">
                                      {errors.name}
                                    </div>
                                  )}
                                </div>
                                <div className="mb-3 mt-5">
                                  <label className="mb-2 fw-bold2">
                                    Correo Electrónico:
                                  </label>
                                  <Field
                                    type="text"
                                    name="email"
                                    className="form-control"
                                    value={initialValues.email}
                                    placeholder="Ingrese su correo electrónico"
                                    onChange={(e) => {
                                      setFieldValue("email", e.target.value);
                                      setInitialValues({
                                        ...initialValues,
                                        email: e.target.value,
                                      });
                                    }}
                                  />
                                  {errors.email && touched.email && (
                                    <div className="invalid-feedback d-block">
                                      {errors.email}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-sm-12">
                                <p className="mt-5 h3 fw-bold">Datos de la gestión</p>
                                <div className="mb-3">
                                  <label className="mb-2 fw-bold2">Canal de atención:</label>
                                  <select
                                    name="typeChat"
                                    className="form-select"
                                    value={initialValues.typeChat}
                                    onChange={(e) => {
                                      setFieldValue("typeChat", e.target.value);
                                      setInitialValues({
                                        ...initialValues,
                                        typeChat: e.target.value,
                                      });
                                      urlChange(e);
                                    }}
                                  >
                                    <option value="1">Servicio al cliente</option>
                                    <option value="2">Cobros</option>
                                  </select>
                                  {errors.typeChat && touched.typeChat && (
                                    <div className="invalid-feedback d-block">
                                      {errors.typeChat}
                                    </div>
                                  )}
                                </div>
                                <div className="mb-3 mt-5">
                                  <label className="mb-2 fw-bold2">Asunto:</label>
                                  <Field
                                    as="textarea"
                                    name="detail"
                                    className="form-control"
                                    value={initialValues.detail}
                                    placeholder="Describa brevemente la gestión que desea realizar"
                                    rows={6}
                                    onChange={(e) => {
                                      setFieldValue("detail", e.target.value);
                                      setInitialValues({
                                        ...initialValues,
                                        detail: e.target.value,
                                      });
                                    }}
                                  />
                                  {errors.detail && touched.detail && (
                                    <div className="invalid-feedback d-block">
                                      {errors.detail}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-sm-12">
                                <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                                  <Button
                                    variant="primary"
                                    className="mt-3 btn-lg"
                                    type="submit"
                                  >
                                    Iniciar Chat
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </>
            ) : (
              <>
                <div className="subtitulo_tt">{Parser(textoChatIniciado)}</div>
                <ChatDesol payload={initialValues} url={url} />
              </>
            )}
          </>
        ) : (
          <div className={"subtitulo_tt"}>{Parser(mensajeFueraHorario)}</div>
        )}
      </div>
    </div>
  );
}

export default ChatFormulario;
